import axios from '../../axios'
import { makeObservable } from 'mobx'
import {
  BillingConfig,
  BillingConfigType,
  BillingCostFilter,
  TrainingBillingConfig,
} from './types'
import { toast } from 'react-toastify'

export class BillingStore {
  constructor() {
    makeObservable(this, {})
  }

  reset = () => {}

  getSystemPredictionBillingConfig = async () => {
    return await axios(`/api/v1/billing/configuration/prediction`).then(
      ({ data }) => data
    )
  }

  updateSystemPredictionBillingConfig = async (config: BillingConfig) => {
    return await axios
      .put(`/api/v1/billing/configuration/prediction/${config.id}`, config)
      .then(({ data }) => data)
  }

  getPredictionBillingConfig = async (
    type: BillingConfigType,
    objectId: number
  ) => {
    return await axios(
      `/api/v1/billing/configuration/prediction/${type}/${objectId}`
    ).then(({ data }) => data)
  }

  updatePredictionBillingConfig = async (
    type: BillingConfigType,
    objectId: number,
    config: any
  ) => {
    return await axios
      .put(
        `/api/v1/billing/configuration/prediction/${type}/${objectId}/${config?.id}`,
        config
      )
      .then(({ data }) => data)
  }
  deletePredictionBillingConfig = async (
    type: BillingConfigType,
    objectId: number
  ) => {
    return await axios
      .delete(`/api/v1/billing/configuration/prediction/${type}/${objectId}`)
      .then(({ data }) => data)
  }

  addPredictionBillingConfig = async (
    type: BillingConfigType,
    objectId: number,
    config: BillingConfig
  ) => {
    return await axios
      .post(
        `/api/v1/billing/configuration/prediction/${type}/${objectId}`,
        config
      )
      .then(({ data }) => data)
  }

  getSystemTrainingBillingConfig = async () => {
    return await axios(`/api/v1/billing/configuration/training`).then(
      ({ data }) => data
    )
  }

  parseTrainingBillingConfig = (config: TrainingBillingConfig) => {
    return {
      ...config,
      cost: config.useFixedCost ? config.cost : null,
      slicesCostConfiguration: config.useFixedCost
        ? null
        : config.slicesCostConfiguration,
      delCost: config.useDelFixedCost ? config.delCost : null,
      delSlicesCostConfiguration: config.useDelFixedCost
        ? null
        : config.delSlicesCostConfiguration,
    }
  }

  updateSystemTrainingBillingConfig = async (config: TrainingBillingConfig) => {
    return await axios
      .put(
        `/api/v1/billing/configuration/training`,
        this.parseTrainingBillingConfig(config)
      )
      .then(({ data }) => data)
  }

  getTrainingBillingConfig = async (
    type: BillingConfigType,
    objectId: number
  ) => {
    return await axios(
      `/api/v1/billing/configuration/training/${type}/${objectId}`
    ).then(({ data }) => data)
  }

  updateTrainingBillingConfig = async (
    type: BillingConfigType,
    objectId: number,
    config: any
  ) => {
    return await axios
      .put(
        `/api/v1/billing/configuration/training/${type}/${objectId}`,
        this.parseTrainingBillingConfig(config)
      )
      .then(({ data }) => data)
  }
  deleteTrainingBillingConfig = async (
    type: BillingConfigType,
    objectId: number
  ) => {
    return await axios
      .delete(`/api/v1/billing/configuration/training/${type}/${objectId}`)
      .then(({ data }) => data)
  }

  addTrainingBillingConfig = async (
    type: BillingConfigType,
    objectId: number,
    config: TrainingBillingConfig
  ) => {
    return await axios
      .post(
        `/api/v1/billing/configuration/training/${type}/${objectId}`,
        this.parseTrainingBillingConfig(config)
      )
      .then(({ data }) => data)
  }

  clearCostInUsageObjects = async (body: BillingCostFilter) => {
    return await axios
      .put(`/management/api/v1/usage/subscription/update/cost`, body)
      .then(({ data }) => {
        toast.success('Billing usage cost cleared successfully')
        return data
      })
  }

  getUsageObjectsCount = async (query: string) => {
    return await axios
      .get(`/management/api/v1/usage/subscription/count?${query}`)
      .then(({ data }) => data)
  }
}

export const billingStore = new BillingStore()
